import { ApolloClient } from "apollo-client"
import { HttpLink } from "apollo-link-http"
import { RetryLink } from "apollo-link-retry"
import { InMemoryCache } from "apollo-cache-inmemory"
import { onError } from "apollo-link-error"
import { IntrospectionFragmentMatcher } from "apollo-cache-inmemory"
import introspectionQueryResultData from "./fragmentTypes.json"

/* istanbul ignore next */
const loggedOutRedirect = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    switch (networkError.statusCode) {
      case 401: {
        window.location =
          process.env.REACT_APP_AUTH_DOMAIN +
          "/users/sign_in?return_to=" +
          encodeURIComponent(window.location)
        break
      }
      case 403: {
        window.location = "https://www.swipesense.com/"
        break
      }
      default:
      // don't redirect if the error code is something other than the ones explicitly specified above
    }
  } else if (graphQLErrors) {
    throw Error(graphQLErrors.map(JSON.stringify).join(","))
  }
})

// https://www.apollographql.com/docs/react/recipes/fragment-matching.html
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
})

/* istanbul ignore next */
const retryNonAuth = (error, _op) => {
  if (error && error.statusCode === 401) {
    return false
  }
  return !!error
}

const apolloClient = new ApolloClient({
  link: loggedOutRedirect
    .concat(
      new RetryLink({
        attempts: {
          /* istanbul ignore next */
          retryIf: retryNonAuth,
        },
      })
    )
    .concat(
      new HttpLink({
        uri: process.env.REACT_APP_API_ENDPOINT,
        credentials: "include",
      })
    ),
  cache: new InMemoryCache({ fragmentMatcher }),
  defaultOptions: {
    query: {
      errorPolicy: "all",
    },
  },
})

export default apolloClient
